/**
 * color-selector.js — printbrain.jp カラー選択ウィジェット v3
 * 配置先: Assets/color-selector.js
 *
 * 方針:
 *   - カラー未選択でもカートに追加できる
 *   - 未選択の場合は「カラー：未選択」としてカートに表示
 *   - 選択済みの場合は「カラー：ホワイト」のように表示
 *   - カラーごとに別行でカートに表示される（line_properties利用）
 */

(function () {
  'use strict';

  // ============================================================
  // ① カラーリストの取得
  // ============================================================

  function getColors() {
    const el = document.getElementById('pb-color-selector-root');
    if (!el) return [];
    try {
      const parsed = JSON.parse(el.dataset.pbColors || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  // ============================================================
  // ② 状態管理
  // ============================================================

  let selectedColor = null; // nullのまま = 未選択

  function setColor(colorName) {
    selectedColor = colorName;

    document.querySelectorAll('.pb-color-btn').forEach(function (btn) {
      const active = btn.dataset.color === colorName;
      btn.classList.toggle('pb-color-btn--active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    const label = document.getElementById('pb-selected-color-label');
    if (label) {
      label.textContent = colorName;
      label.classList.add('pb-cs-selected--chosen');
    }
  }

  // ============================================================
  // ③ UIの構築
  // ============================================================

  function buildUI(colors) {
    const root = document.getElementById('pb-color-selector-root');
    if (!root || colors.length === 0) {
      if (root) root.style.display = 'none';
      return;
    }

    // ヘッダー
    const header = document.createElement('div');
    header.className = 'pb-cs-header';
    header.innerHTML =
      '<span class="pb-cs-label">カラー：</span>' +
      '<span id="pb-selected-color-label" class="pb-cs-selected">未選択</span>';
    root.appendChild(header);

    // ボタングリッド
    const grid = document.createElement('div');
    grid.className = 'pb-cs-grid';
    grid.setAttribute('role', 'group');
    grid.setAttribute('aria-label', 'カラーを選択');

    colors.forEach(function (item) {
      const name = typeof item === 'string' ? item : item.name;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pb-color-btn';
      btn.dataset.color = name;
      btn.textContent = name;
      btn.setAttribute('aria-pressed', 'false');
      btn.addEventListener('click', function () { setColor(name); });
      grid.appendChild(btn);
    });

    root.appendChild(grid);
  }

  // ============================================================
  // ④ fetch上書き — カラーをline_propertiesに付加
  //    未選択の場合は「未選択」として送信（ブロックしない）
  // ============================================================

  function interceptFetch(colors) {
    if (colors.length === 0) return;

    const originalFetch = window.fetch;

    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : (input.url || '');

      if (url.includes('/cart/add')) {
        const colorValue = selectedColor || '未選択';

        try {
          init = init ? Object.assign({}, init) : {};
          const body = init.body;

          if (typeof body === 'string') {
            // JSON形式
            try {
              const parsed = JSON.parse(body);
              parsed.properties = parsed.properties || {};
              parsed.properties['カラー'] = colorValue;
              init.body = JSON.stringify(parsed);
            } catch (e) {
              // URLエンコード形式
              init.body = body +
                '&properties%5B%E3%82%AB%E3%83%A9%E3%83%BC%5D=' +
                encodeURIComponent(colorValue);
            }
          } else if (body instanceof FormData) {
            const newFd = new FormData();
            for (const pair of body.entries()) {
              newFd.append(pair[0], pair[1]);
            }
            newFd.set('properties[カラー]', colorValue);
            init.body = newFd;
          } else {
            // bodyがない・その他の形式
            const fd = new FormData();
            fd.append('properties[カラー]', colorValue);
            init.body = fd;
          }
        } catch (e) {
          console.warn('[color-selector] bodyの加工に失敗:', e);
        }
      }

      return originalFetch.call(this, input, init);
    };
  }

  // ============================================================
  // ⑤ 初期化
  // ============================================================

  function init() {
    if (!document.getElementById('pb-color-selector-root')) return;

    const colors = getColors();
    buildUI(colors);

    if (colors.length > 0) {
      interceptFetch(colors);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
